import * as d3 from 'd3'

export default {
  methods: {

    call_Layout(selection) {
      this.canvasLayout.remove()
      this.draw_Layout()

      this.set_selectedItems()
    },

    call_Overall(selection) {
      this.current.SVG = 'LQ'
      this.canvasLayout.remove()
      this.draw_Layout()

      this.set_selectedItems()
    },



  }
}